import { useCreateReferenceImage } from 'hooks/queries/schedules/contents/useCreateReferenceImage'
import { useReferenceImageSync } from 'hooks/queries/schedules/contents/useReferenceImage'
import { LoadingShimmerer, ReferenceImg } from 'screens/Schedule/PostPromptsSection/ReferenceImg'
import Styles from 'screens/Schedule/PostPromptsSection/ReferenceImage.module.scss'
import { LoadingImage } from 'screens/Schedule/PostPromptsSection/ReferenceImage'

interface Props {
  scheduleId: number
  contentId: number
  width: number
  height: number
  alt: string
}

export const LazyCreateReferenceImage = ({ scheduleId, contentId, width, height, alt }: Props) => {
  const { mutate: createReferenceImage } = useCreateReferenceImage()
  const { data: referenceImage } = useReferenceImageSync(
    { scheduleId, contentId },
    {
      onSuccess: (data) => {
        if (!data.media_file && !data.status) {
          createReferenceImage({ scheduleId, contentId })
        }
      },
    },
  )

  if (!referenceImage) {
    return <LoadingShimmerer />
  }

  const status = referenceImage.status

  if (['pending', 'processing'].includes(status || '')) {
    return (
      <div className={Styles.image}>
        <LoadingImage />
      </div>
    )
  }

  return <ReferenceImg width={width} height={height} src={referenceImage.media_file?.source_url || ''} alt={alt} />
}
